// extracted by mini-css-extract-plugin
export default {"buttonSectionWrapper":"RTQVkbg27l0Qq5HIWa8w","placeOrderErrorMessage":"mhVpttF3LSOQeHSwGp4b","legalText":"NJFIGj5a1mEbsfdwSo6n"};